export default {
  home: 'Home',
  game: 'Game',
  deposit: 'Deposit',
  activity: 'Activity',
  mine: 'Mine',
  // Destinations used by the artwork-led bar.
  lobby: 'Lobby',
  promotions: 'Promotions',
  discover: 'Discover',
  support: 'Support',
};
